import React, { Component } from 'react';
import { Link } from "react-router-dom";

export class Notifications extends Component {
  render() {
    return (
        <li className="nav-item dropdown">
        <a
            href="#"
            className="dropdown-toggle nav-link"
            data-bs-toggle="dropdown"
        >
            <i className="fa fa-bell-o text-dark" />
            <span className="badge badge-pill">3</span>
        </a>
        <div className="dropdown-menu notifications">
            <div className="topnav-dropdown-header">
                <span className="notification-title">Notifications</span>
                <a href="" className="clear-noti">
                    {" "}
                    Clear All{" "}
                </a>
            </div>
            <div className="noti-content">
                <ul className="notification-list">
                    <li className="notification-message">
                        <Link
                            onClick={() => localStorage.setItem("minheight", "true")}
                            to="/app/administrator/activities"
                        >
                            <div className="media">
                                <span className="avatar">
                                    <img alt="" src={""} />
                                </span>
                                <div className="media-body">
                                    <p className="noti-details">
                                        <span className="noti-title">John Doe</span> added new
                                        task{" "}
                                        <span className="noti-title">
                                            Patient appointment booking
                                        </span>
                                    </p>
                                    <p className="noti-time">
                                        <span className="notification-time">4 mins ago</span>
                                    </p>
                                </div>
                            </div>
                        </Link>
                    </li>
                </ul>
            </div>
            <div className="topnav-dropdown-footer">
                <Link
                    onClick={() => localStorage.setItem("minheight", "true")}
                    to="/app/administrator/activities"
                >
                    View all Notifications
                </Link>
            </div>
        </div>
    </li>
    )
  }
}

export default connect(Notifications);